// extracted by mini-css-extract-plugin
export var quantityInput = "_gk-0";